import { Helmet } from "react-helmet-async";
import { InsightsGrid } from "@/components/insights";
import { useAuth } from "@/contexts/AuthContext";
import { NoPracticeState } from "@/components/shared/NoPracticeState";

export default function Scorecards() {
  // No-practice gate (same pattern as APP Plus's NoAcoState) — synchronous,
  // no loading flash.
  const { user, loading: authLoading, selectedPractice } = useAuth();
  if (!authLoading && user !== undefined && !selectedPractice) return <NoPracticeState />;
  return (
    <>
      <Helmet>
        <title>Insights | MIPS Reports & Analytics</title>
        <meta name="description" content="Access MIPS reports and analytics including payment adjustments, performance trends, and benchmarking." />
        <link rel="canonical" href="/scorecards" />
      </Helmet>
      
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold">Insights</h1>
          <p className="mt-1 text-muted-foreground">
            Reports and analytics to help you understand and improve your MIPS performance.
          </p>
        </div>

        <InsightsGrid />
      </div>
    </>
  );
}
